import {
  ConfigurationSummaryStepTranslation,
  RequestQuoteLinkTranslation,
} from '../../../../../../localization/SiteTranslation';
import RequestQuoteLink from '../../../../../../requestQuote/RequestQuoteLinkButton/RequestQuoteLink';
import ActionButton from '../../../../../../shared/components/ActionButton';
import ModularConfiguratorSummaryState from '../ModularConfiguratorSummaryState';
import css from './ModularConfigurationPurchaseActions.css';

export interface ModularConfigurationPurchaseActionsProps {
  state: {
    configuratorSummaryState: ModularConfiguratorSummaryState;
    translation: ConfigurationSummaryStepTranslation;
    requestQuoteLinkTranslation: RequestQuoteLinkTranslation;
  };
}

const ModularConfigurationPurchaseActions = ({
  state: {
    configuratorSummaryState: {
      configurationCode,
      isCodeGenerationInProgress,
      isPurchaseEnabled,
      proceedToCheckoutCommand,
      proceedToRequestQuoteCommand,
    },
    requestQuoteLinkTranslation,
    translation,
  },
}: ModularConfigurationPurchaseActionsProps) => {
  return (
    <div className={css.container}>
      {isPurchaseEnabled ? (
        <>
          <ActionButton command={proceedToCheckoutCommand} disabled={isCodeGenerationInProgress}>
            {translation.checkoutButton}
          </ActionButton>
          <RequestQuoteLink
            translation={requestQuoteLinkTranslation}
            className={css.requestQuoteLink}
            configurationCode={configurationCode}
            disabled={isCodeGenerationInProgress}
          />
        </>
      ) : (
        <ActionButton command={proceedToRequestQuoteCommand} disabled={isCodeGenerationInProgress}>
          {translation.requestQuoteButton}
        </ActionButton>
      )}
    </div>
  );
};

export default ModularConfigurationPurchaseActions;
